import axiosInstance from '@/plugins/connectionBuilder.js'

export default {
    state: {
        alerts: [],
        isLoading: false,
    },
    mutations: {
        setAlerts(state, alerts) {
            state.alerts = alerts
        },
        setAlertsLoading(state, isLoading) {
            state.isLoading = isLoading
        },
    },
    actions: {
        getAlerts({ commit, dispatch }) {
            commit('setAlertsLoading', true)
            return axiosInstance.post('lifts/getAlerts')
                .then(function (response) {
                    commit('setAlerts', response.data.message)
                })
                .catch(function (error) {
                    if (error.response && error.response.data.message) {
                        dispatch("addNotification", { message: error.response.data.message, type: "error" })
                    }
                })
                .finally(function () {
                    commit('setAlertsLoading', false)
                })
        },
        setAlertReadStatus({ dispatch }, { alert_id, is_read }) {
            return axiosInstance.post('lifts/markAlertRead', { alert_id, is_read })
                .then(function () {
                    dispatch('getAlerts')
                })
                .catch(function (error) {
                    if (error.response && error.response.data.message) {
                        dispatch("addNotification", { message: error.response.data.message, type: "error" })
                    }
                })
        },
        archiveAlert({ dispatch }, alert_id) {
            return axiosInstance.post('lifts/archiveAlert', { alert_id })
                .then(function () {
                    dispatch('getAlerts')
                })
                .catch(function (error) {
                    if (error.response && error.response.data.message) {
                        dispatch("addNotification", { message: error.response.data.message, type: "error" })
                    }
                })
        },
        runAlertsDetection({ dispatch }) {
            // Lance la détection côté serveur (indépendante de l'état signé du registre)
            // puis rafraîchit la liste. Les erreurs sont silencieuses (non bloquant pour l'UI).
            return axiosInstance.post('lifts/runAlertsDetection')
                .then(function () {
                    dispatch('getAlerts')
                })
                .catch(function () {
                    // En cas d'échec de la détection, on tente quand même un simple rafraîchissement
                    dispatch('getAlerts')
                })
        },
    },
}
